import { Document, Page, View, StyleSheet, Text, Image, Font } from "@react-pdf/renderer";
import imgKkp from '../../../assets/images/logo_kkp.jpg'
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import { formatDateStringLocalDateINA } from "../../../utilities/Utils";

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 250,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const EvadanRekomTeknisKapal = ({ dataDisposisi, dataPpmKapal }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [listChecklistCheck, setListChecklistCheck] = useState([])
    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [listEvaluasi, setListEvaluasi] = useState(null)
    const [dataRekom, setDataRekom] = useState(null)
    const [dataApproval, setDataApproval] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)
    const [dataSTDetil, setDataSTDetil] = useState(null)
    const [listSTDetil, setListSTDetil] = useState(null)
    const [isUnder5GT, setIsUnder5GT] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            let isOver5Gt = dataPpmKapal.ukuranKapal <= 5 ? 'T' : 'Y'
            let isPembeku = dataPpmKapal.fasilitasPembeku === '1' ? 'Y' : 'T'
            setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

            const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
            if (resDataInspeksi) {
                const idInspeksi = resDataInspeksi.data.idInspeksi
                setDataInspeksi(resDataInspeksi.data)

                const results = await Promise.allSettled([
                    kapalService.listEvaluasiTeknisByIdInspeksi(idInspeksi),
                    kapalService.checklistCek(isOver5Gt, isPembeku),
                    kapalService.listRekomTeknis(idInspeksi),
                    kapalService.listApprovalTeknis(idInspeksi),
                    kapalService.getMasterKapalById(dataPpmKapal.idKapal),
                    kapalService.getPenugasanByAjuAndIdDisposisi(dataPpmKapal.nomorAjuKapal, 2)
                ])

                const [resEvaluasi, resChecklistCheck, resRekom, resApproval, resMasterKapal, resST] = results

                const getData = (res, fallback = []) =>
                    res.status === "fulfilled"
                        ? res.value?.data?.data ?? res.value?.data ?? fallback
                        : fallback;

                setListEvaluasi(getData(resEvaluasi))
                setListChecklistCheck(getData(resChecklistCheck))
                setDataRekom(resRekom.value?.data?.data[0])
                setDataApproval(resApproval.value?.data?.data[0])
                setMasterKapal(getData(resMasterKapal))

                const resSTDetil = await kapalService.getFirstPenugasanDetilByIdProses(resST.value?.data?.idProses)
                setDataSTDetil(resSTDetil.data)

                const resSTDetilAll = await kapalService.listPenugasanDetilAll(resST.value?.data?.idProses)
                setListSTDetil(resSTDetilAll.data)
            }
        } catch (error) {
            console.log(error)
        }
    }, [dataDisposisi, dataPpmKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page} fixed>
                <View style={[styles.table, { marginBottom: 3 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#0000ff' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#0000ff' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JALAN MEDAN MERDEKA TIMUR NO. 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>LAMAN www.kkp.go.id</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center' }]}>EVALUASI DAN REKOMENDASI TEKNIS</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Nama Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.namaKapal}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Status Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.statusPermohonan === '1' ? 'Baru' : 'Perpanjangan')}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Jenis Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '75%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && (dataPpmKapal.jenisKapal === '1' ? 'Penangkap' : 'Pembeku')}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ukuran Kapal</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '75%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataPpmKapal && dataPpmKapal.ukuranKapal}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Alamat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '75%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{masterKapal && masterKapal.alamatPemilik}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ketua Tim</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataSTDetil && dataSTDetil.nmPetugas}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '35%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Anggota</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1 }]}>
                            {
                                listSTDetil && listSTDetil.map((stdtl, idx) => {
                                    return (
                                        idx !== 0 && <Text key={stdtl.idProsesDtl} style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{stdtl.nmPetugas}</Text>
                                    )
                                })
                            }
                        </View>
                        <View style={[styles.tableCol, { width: '35%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tgl Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{dataInspeksi && formatDateStringLocalDateINA(dataInspeksi.tglInspeksi)}</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Tgl rencana perbaikan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '25%', borderTop: 1, borderLeft: 1, borderRight: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 1, paddingBottom: 2 }]}>
                    <View style={[styles.tableRow, { marginBottom: 2 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'left' }]}>Hasil Inspeksi Tim Inspeksi</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '46%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Hasil Inspeksi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderLeft: 1, borderRightWidth: 1, borderTop: 1 }]}>
                            <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: "center" }]}>
                                        Kriteria Ketidaksesuaian
                                    </Text>
                                </View>
                            </View>
                            {/* <View style={[styles.tableRow]}>
                                <View style={[styles.tableCol, { width: "34%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: "center" }]}>
                                        Mn
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "34%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: "center" }]}>
                                        My
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "32%", alignItems: "center", borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 12, textAlign: "center" }]}>
                                        Kr
                                    </Text>
                                </View>
                            </View> */}
                        </View>
                        {
                            listChecklistCheck && listChecklistCheck.map((check, idx) => {
                                return <DataHasilInspeksi kodeTipe={check.kodeTipe} nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnder5GT={isUnder5GT} />
                            })
                        }
                        {/* <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <View style={[styles.tableCol, { width: "4%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}>1</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "46%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", alignItems: "center", borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <View style={[styles.tableCol, { width: "4%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}>2</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "46%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", alignItems: "center", borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                        </View>
                        <View style={[styles.tableRow, { borderLeftWidth: 1, borderRightWidth: 1 }]}>
                            <View style={[styles.tableCol, { width: "4%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "46%", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}>dan seterusnya</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "17%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "16%", alignItems: "center", borderBottomWidth: 1 }]}>
                                <Text style={styles.text}></Text>
                            </View>
                        </View> */}
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 1, paddingBottom: 2 }]}>
                    <View style={[styles.tableRow, { marginBottom: 2 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'left' }]}>Evaluasi Tim Teknis</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 1 }]}>
                    <View style={[styles.tableRow, { borderBottom: 1 }]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Nama</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Catatan Tim Teknis</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tgl</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tanda tangan</Text>
                        </View>
                    </View>
                    {
                        listEvaluasi && listEvaluasi.map((ev, idx) => {
                            return (
                                <View key={idx} style={[styles.tableRow, { borderBottom: 1 }]}>
                                    <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{idx + 1}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{ev.nmEvaluator}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '40%', borderTop: 1, borderLeft: 1 }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{ev.catatanEvaluator}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1 }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{formatDateStringLocalDateINA(ev.tglEvaluasi)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                                        <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                                    </View>
                                </View>

                            )
                        })
                    }
                </View>
                <View style={[styles.table, { paddingTop: 3, paddingBottom: 1 }]}>
                    <View style={[styles.tableRow, { marginBottom: 2 }]}>
                        <View style={[styles.tableCol, { width: '100%' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'left' }]}>Rekomendasi</Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { paddingTop: 1 }]}>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>No</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Pelaksana</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tahapan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Hasil</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tgl</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderTop: 1, borderLeft: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'center' }]}>Tanda tangan</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>1</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Ketua Tim Kerja Pengendalian dan Pengawasan Mutu Hasil Tangkapan serta Pemantauan Perairan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Usulan Rekomendasi</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Direkomendasikan/ tidak Direkomendasikan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderLeft: 1, borderTop: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderLeft: 1, borderTop: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>2</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '30%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Kepala Pusat Mutu Produksi Primer</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Persetujuan</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '20%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>Disetujui/ Ditolak</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderLeft: 1, borderTop: 1, borderBottom: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                        <View style={[styles.tableCol, { width: '13%', borderLeft: 1, borderTop: 1, borderBottom: 1, borderRight: 1 }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    )
}

const DataHasilInspeksi = ({ kodeTipe, nomorAjuKapal, isUnder5GT }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [listParam, setListParam] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            // setLoading(true)
            try {
                const resParam = await kapalService.checklistParamInspeksi(kodeTipe)
                setListParam(resParam.data.data)
            } catch (error) {

            }
            // setLoading(false)
        }
        fetchAllData()
    }, [kapalService, kodeTipe])

    return (
        <>
            {listParam &&
                listParam.map((param, idx) => {
                    return (
                        <DetilHasilInspeksi kodeParameterInspeksi={param.kodeParameterInspeksi} nomorAjuKapal={nomorAjuKapal} isUnder5GT={isUnder5GT} indexparam={idx} param={param} />
                    )
                })
            }
        </>
    )
}

const DetilHasilInspeksi = ({ kodeParameterInspeksi, nomorAjuKapal, isUnder5GT, indexparam, param }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [listHasil, setListHasil] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const resHasil = await kapalService.listHasilInspeksi(nomorAjuKapal, kodeParameterInspeksi, isUnder5GT)
                setListHasil(resHasil.data.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, kodeParameterInspeksi, nomorAjuKapal, isUnder5GT])

    return (
        <>
            {
                listHasil &&
                listHasil.map((hasil, idx) => {
                    const valueHasil = (nilai) => {
                        if (isUnder5GT === 'Y') {
                            return 'Tidak Sesuai'
                        } else {
                            if (nilai === 1) {
                                return 'Kritis'
                            } else if (nilai === 2) {
                                return 'Mayor'
                            } else if (nilai === 3) {
                                return 'Minor'
                            }
                        }
                    }
                    return (
                        <View key={indexparam + idx} style={[styles.tableRow]}>
                            {
                                idx === 0 ?
                                    <>
                                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{indexparam + 1}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '46%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{param.uraianParameterInspeksi}</Text>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{hasil.uraianTargetNilai}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '50%', borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{hasil?.keterangan} ({valueHasil(hasil.nilai)})</Text>
                                        </View>
                                    </>
                                    :
                                    <>
                                        <View style={[styles.tableCol, { width: '4%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}></Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '46%', borderTop: 1, borderLeft: 1, borderBottom: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{hasil.uraianTargetNilai}</Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: '50%', borderTop: 1, borderLeft: 1, borderBottom: 1, borderRight: 1 }]}>
                                            <Text style={[styles.text, { fontSize: 12, textAlign: 'left' }]}>{hasil?.keterangan} ({valueHasil(hasil.nilai)})</Text>
                                        </View>
                                    </>
                            }
                        </View>
                    )
                })
            }
        </>
    )
}

export default EvadanRekomTeknisKapal